module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-login-v3 layout-full th"
  }, [_c('div', {
    staticClass: "page vertical-align text-xs-center"
  }, [_c('div', {
    staticClass: "page-content vertical-align-middle"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body panel-form"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$t('forgot.action.forgotPassword')))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('forgot.labels.prefixResetPassword')) + " "), _c('span', {
    staticClass: "blue-600 text-uppercase"
  }, [_vm._v(_vm._s(_vm.$route.params.namespace))]), _vm._v(" " + _vm._s(_vm.$t('forgot.labels.subfixResetPassword')))]), _vm._v(" "), _c('alert', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showAlert),
      expression: "showAlert"
    }],
    attrs: {
      "alertClass": "alert-dismissible",
      "type": ("" + ((_vm.successResponse) ? 'success' : 'danger')),
      "iconClass": ("" + ((_vm.successResponse) ? 'wb-check' : 'wb-close'))
    }
  }, [(_vm.successResponse) ? _c('span', [_vm._v(_vm._s(_vm.successResponse))]) : (_vm.errorResponse) ? _c('span', [_vm._v(_vm._s(_vm.errorResponse))]) : _vm._e()]), _vm._v(" "), (!this.successResponse) ? _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.onSubmit($event)
      }
    }
  }, [_c('div', {
    staticClass: "user-form"
  }, [_c('form-group', {
    attrs: {
      "error": _vm.formErrors.first('email')
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "email",
      "placeholder": _vm.$t('account.labels.email')
    },
    domProps: {
      "value": _vm._s(_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-block btn-primary btn-lg btn-submit",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(_vm._s(_vm.$t('forgot.action.sendRequest')))])], 1)]) : _vm._e(), _vm._v(" "), _c('p', {
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.$t('action.backTo')) + " "), _c('u', [_c('router-link', {
    staticClass: "btn btn-link btn-register",
    attrs: {
      "to": ("/" + (_vm.$route.params.namespace) + "/login")
    }
  }, [_vm._v(_vm._s(_vm.$t('action.login')))])], 1)])], 1)]), _vm._v(" "), _vm._m(1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "brand"
  }, [_c('img', {
    staticClass: "brand-img",
    attrs: {
      "src": "/static/images/byteark-loading-white.png",
      "alt": "logo account",
      "width": "180"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "brand-text font-size-24 grey-100"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "page-copyright page-copyright-inverse"
  }, [_c('p', [_vm._v("Service by ByteArk.com")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4c0cf0f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forgot/ForgotPassword.vue
// module id = 530
// module chunks = 1